import { createContext, useContext, useState, useCallback } from "react";
import { AuditDialog } from "@/components/AuditDialog";

const AuditContext = createContext({ openAudit: () => {} });

export const useAudit = () => useContext(AuditContext);

export const AuditProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [variant, setVariant] = useState("default");
  // Accepte un variant optionnel : openAudit("promo"). Utilisé aussi comme
  // handler onClick, où le 1er argument est l'évènement → on retombe sur "default".
  const openAudit = useCallback((v) => {
    setVariant(typeof v === "string" ? v : "default");
    setOpen(true);
  }, []);
  return (
    <AuditContext.Provider value={{ openAudit }}>
      {children}
      <AuditDialog open={open} onOpenChange={setOpen} variant={variant} />
    </AuditContext.Provider>
  );
};
